import { render, staticRenderFns } from "./instruction.vue?vue&type=template&id=58799299&scoped=true&"
import script from "./instruction.vue?vue&type=script&lang=js&"
export * from "./instruction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58799299",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58799299')) {
      api.createRecord('58799299', component.options)
    } else {
      api.reload('58799299', component.options)
    }
    module.hot.accept("./instruction.vue?vue&type=template&id=58799299&scoped=true&", function () {
      api.rerender('58799299', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/instruction.vue"
export default component.exports